import { render } from "./SportsBar.vue?vue&type=template&id=4e288358&scoped=true"
import script from "./SportsBar.vue?vue&type=script&lang=js"
export * from "./SportsBar.vue?vue&type=script&lang=js"

import "./SportsBar.vue?vue&type=style&index=0&id=4e288358&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dj_Volodya\\PycharmProjects\\7scalesProjects\\GeoffBanks\\geoff-banks-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e288358"]])

export default __exports__